import Cookies from 'js-cookie';
import { CookieKey } from './cookie-keys.const';

Cookies.defaults.domain = location.hostname;
(window as any).jsCookie = Cookies;

export function getCookie(cookieName: CookieKey) {
  if (typeof document === 'undefined') return null;

  return Cookies.get(cookieName);
}

export function setCookie(...args): string {
  return Cookies.set(...args);
}

/**
 * Function for removing a cookie from application storage
 * @param key name/key of the cookie
 */
export function removeCookie(key: CookieKey, options?: { path?: string, domain?: string }): void {
  if (!!options) return Cookies.remove(key, options);
  return Cookies.remove(key);
}
